/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-alert */
import React, { useState, useContext } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import AppStateContext from "../../context/appStateContext";

import LoginRequest from '../../../hooks/loginRequest';
import ErrorBox from "../../../components/errorBox";
import {
  InputBox,
  PasswordDiv,
  Form,
  SignIn,
  ShowButton,
  SubmitButton,
} from './index.style';

import Icons from '../../../assets/icons';
import {navigate} from "@reach/router";

const LoginForm: React.FC<any> = (...restProps): React.ReactElement => {
  const { contactEmail } = useContext(AppStateContext);

  const [pwToggle, setPwToggle] = useState('password');
  const [showIcon, setShowIcon] = useState(<Icons.eye />);
  const [showText, setShowText] = useState('Show');
  const [errorDisp, setErrorDisp] = useState(false);
  const [ submitted, setSubmitted ] = useState(false);

  const callback = (success: boolean) => {
    if (!success) {
      setErrorDisp(true);
    } else {
      navigate('/app/selectContract')
    }
  };

  const { handleInputChange, handleSubmit } = LoginRequest(callback);

  const submit = async (event: any) => {
    setSubmitted(true);
    await handleSubmit(event);
    setSubmitted(false);
  };

  const toggleShow = () => {
    if (pwToggle === 'password') {
      setPwToggle('text');
      setShowIcon(<Icons.eyeOff />);
      setShowText('Hide');
    } else {
      setPwToggle('password');
      setShowIcon(<Icons.eye />);
      setShowText('Show');
    }
  };

  return (
    <Form onSubmit={submit}>
      <ErrorBox text={<span>We couldn't find an account with these details. Please try again. <br/> If you still can’t find your details, please email {contactEmail}</span>} active={errorDisp}/>
      <SignIn>Sign in to begin</SignIn>
      <InputBox type="text" placeholder="Your username" name="userName" onChange={handleInputChange} />
      <PasswordDiv>
        <InputBox type={pwToggle} placeholder="Your password" name="password" onChange={handleInputChange} />
        <ShowButton type="button" onClick={() => toggleShow()}>
          {showIcon}
          <span>{showText}</span>
        </ShowButton>
      </PasswordDiv>
      <SubmitButton type="submit" value="SIGN IN" disabled={submitted}/>
    </Form>
  );
};

export default LoginForm;
